export default "//yastatic.net/s3/distribution/pythia/frontend/_/3b5bc32fb1d3084e8026a67dc58c120f.png";